(ns ncr.tour
  (:require
   [uix.core.alpha :as uix]
   [clojure.core.match :refer [match]]
   [cljs.core.async :as async :refer-macros [go]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [ncr.me :as me]
   [ncr.etc.util :as u]
   [ncr.widgets.util :as wu]
   [ncr.amplitude :as a]
   [ncr.navigate :as nav]
   ["@flows/js" :as flow]))

(def flow-id "introduction")

(defn start! []
  (flow/endFlow flow-id)
  (nav/push-search! "")
  (flow/startFlow flow-id))

(defn step [{:keys [id title body target overlay hide-next? placement] :or {overlay true hide-next? false placement "bottom"}}]
  (merge
    {"stepId" id
     "title" (wu/render-to-string [:section.ncr-c-tour__title title])
     "body" (wu/render-to-string [:section.ncr-c-tour__body body])
     "hideNext" hide-next?}
    (when (some? target)
      {"targetElement" (u/format "[data-tour-target=\"%s\"]" target)
       "placement" placement})
    (when overlay
      {"overlay" true
       "closeOnOverlayClick" false})))

(def steps
  [{:id "intro"
    :title "Welcome to the NECKAR guided tour."
    :body [:p "In the next few minutes we will demonstrate main NECKAR features and operations."]
    :overlay false}

   {:id "sidebar"
    :title "Navigation Bar"
    :body "There is a navigation bar on the left. It contains folders, labels, and other links."
    :target "sidebar"}

   {:id "search-bar"
    :title "Search Bar"
    :body "In the search bar you can enter queries, to find required documents. It works exactly like in Google Mail."
    :target "search-input"}

   {:id "documents"
    :title "Documents List"
    :body "On The right you see a documents list. These documents are produced by a search you type in the search query."
    :target "search"}

   {:id "try-search"
    :title "Search Bar"
    :body "Now please type 'Vodafone' in the search field, and press enter."
    :overlay false
    :hide-next? true
    :placement "bottom-start"
    :target "search-input"
    :expect {:type :route :name :search :query "Vodafone"}}

   {:id "success"
    :title "Success"
    :body "You successfully complete NECKAR tutorial"
    :overlay false}])

(defn c-tour [route-data]
  (let [by-id (u/index-by :id steps)]
    (uix/with-effect [route-data]
      (when-let [{:keys [expect]} (some-> (flow/getCurrentStep flow-id) (.-stepId) (by-id))]
        (when (= expect (assoc (select-keys route-data (keys expect)) :type :route) expect)
          (flow/nextStep flow-id)))))

  (let [{:keys [email name cluster]} (uix/context me/*context*)]
    (uix/with-effect []
      (let
        [user-id (case email "demo@neckar.io" (a/device-id) email)
         props {:email email :name name :cluster (:slug cluster)}]

        (go
          (<p!
            (flow/init
              (clj->js
                {"projectId" "71f77a7d-e950-44a8-881a-03b09d5cbcab"
                 "flows"
                 [{"id" flow-id
                   "frequency" "every-time"
                   "steps" (map step steps)}]
                 "userId" user-id
                 "userProperties" props})))))))
  nil)